import { HttpClient, APIResponse } from '@zeta-core';
import { SUPPORT_TICKET_SERVICE } from '../services-path';
import {
  IAddCommentRequest,
  IAddCommentResponse,
  ICreateSupportTicketRequest,
  ICreateSupportTicketResponse,
  IGetSupportTicketRequest,
  IGetSupportTicketResponse,
  IListSupportTicketsResponse,
} from './types';
import {IEmptyRequestResponse} from '@zeta-types';
export * from './types';

export const SupportTicketService = () => {
  return {
    /**
     * Create a new support ticket
     * @param payload - Ticket creation data
     * @returns Promise with created ticket
     */
    createTicket: (payload: ICreateSupportTicketRequest): APIResponse<ICreateSupportTicketResponse> =>
      HttpClient.post(`${SUPPORT_TICKET_SERVICE}/support/create`, payload),

    /**
     * Get list of support tickets with filters and pagination
     * @param payload - Request parameters for filtering and pagination
     * @returns Promise with list of tickets and pagination info
     */
    listTickets: (payload: IEmptyRequestResponse): APIResponse<IListSupportTicketsResponse> =>
      HttpClient.post(`${SUPPORT_TICKET_SERVICE}/support/list`, payload),

    /**
     * Get single support ticket details by ID
     * @param ticketId - Support ticket ID
     * @returns Promise with ticket details including all comments
     */
    getTicketById: (payload: IGetSupportTicketRequest): APIResponse<IGetSupportTicketResponse> =>
      HttpClient.post(`${SUPPORT_TICKET_SERVICE}/support/details`, payload),

    /**
     * Add a comment/reply to a support ticket
     * @param payload - Comment data
     * @returns Promise with created comment and updated ticket
     */
    addComment: (payload: IAddCommentRequest): APIResponse<IAddCommentResponse> => HttpClient.post(`${SUPPORT_TICKET_SERVICE}/support/comment`, payload),
  };
};
